module.exports = __webpack_public_path__ + "img/image2@3x.911c24d1.png";